import { Tag, Typography } from "antd";

const { Text } = Typography;

const ChargeDetails = ({ chargeData, currencySymbol }) => {
  const data = [
    {
      section: "Tax & Charges",
      items: [
        {
          isInlineGroup: true,
          group: [
            {
              name: "Tax Group",
              isTagGroup: true,
              fields: [
                {
                  value: chargeData?.allowTax ?? "-",
                  isTag: true,
                },
                {
                  value: chargeData?.taxGroup?.name || "-",
                  isTag: true,
                },
                {
                  value: chargeData?.taxGroup?.taxAssociations[0]?.taxComponent
                    ?.percentage
                    ? `%${chargeData?.taxGroup?.taxAssociations[0]?.taxComponent?.percentage?.toLocaleString()}`
                    : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Processing Charges",
              isTagGroup: true,
              fields: [
                {
                  value: chargeData?.setupCharges ?? "-",
                  isTag: true,
                },
                {
                  value: chargeData?.setupCharge?.name || "-",
                  isTag: true,
                },
                {
                  value: chargeData?.setupCharge?.amount
                    ? `${currencySymbol}${chargeData?.setupCharge?.amount?.toLocaleString()}`
                    : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Redemption Charges",
              isTagGroup: true,
              fields: [
                {
                  value: chargeData?.redemptionCharges ?? "-",
                  isTag: true,
                },
                {
                  value: chargeData?.redemptionCharge?.name || "-",
                  isTag: true,
                },
                {
                  value: chargeData?.redemptionCharge?.amount
                    ? `${currencySymbol}${chargeData?.redemptionCharge?.amount?.toLocaleString()}`
                    : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Stamp Duty Charges",
              isTagGroup: true,
              fields: [
                {
                  value: chargeData?.transferCharges ?? "-",
                  isTag: true,
                },
                {
                  value: chargeData?.transferCharge?.name || "-",
                  isTag: true,
                },
                {
                  value: chargeData?.transferCharge?.amount
                    ? `${currencySymbol}${chargeData?.transferCharge?.amount?.toLocaleString()}`
                    : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Brokerage/Agent Commission",
              isTagGroup: true,
              fields: [
                {
                  value: chargeData?.allowBrokerage ?? "-",
                  isTag: true,
                },
                {
                  value: chargeData?.commission?.name || "-",
                  isTag: true,
                },
                {
                  value: chargeData?.commission?.amount
                    ? `${currencySymbol}${chargeData?.commission?.amount?.toLocaleString()}`
                    : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
      ],
    },
  ];

  const renderTag = (value) => {
    if (value === true) {
      return (
        <Tag
          style={{
            backgroundColor: "#ECFDF3",
            border: "1px solid #ABEFC6",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#067647",
              fontWeight: 600,
            }}
          >
            Yes
          </Text>
        </Tag>
      );
    }

    if (value === false) {
      return (
        <Tag
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "16px",
            padding: "2px 12px",
            textTransform: "capitalize",
          }}
        >
          <Text
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            No
          </Text>
        </Tag>
      );
    }

    if (
      value === "-" ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return <Text style={{ fontWeight: 500, color: "#6b7280" }}>-</Text>;
    }

    // Default tag for select fields
    return (
      <Tag
        style={{
          backgroundColor: "#FDF4FF",
          border: "1px solid #F6D0FE",
          borderRadius: "16px",
          padding: "2px 12px",
        }}
      >
        <Text
          style={{
            textTransform: "capitalize",
            color: "#9F1AB1",
            fontWeight: 600,
          }}
        >
          {value}
        </Text>
      </Tag>
    );
  };

  const renderRow = (item, index, section) => {
    const isLastItem = index === (data[section]?.items?.length || 0) - 1;

    if (item.isInlineGroup && Array.isArray(item.group)) {
      return (
        <div
          key={`inline-group-${section}-${index}`}
          style={{
            display: "flex",
            borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
          }}
        >
          {item.group.map((fieldGroup, groupIndex) => (
            <>
              <div
                key={`group-${groupIndex}`}
                style={{
                  width: "50%",
                  backgroundColor: "#f9f9f9",
                  padding: "16px 24px",
                  fontWeight: "500",
                  borderRight: "1px solid #f0f0f0",
                }}
              >
                {fieldGroup.name}
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  padding: "16px 24px",
                  width: "50%",
                  backgroundColor: "#fff",
                }}
              >
                {fieldGroup.fields.map((subField) => (
                  <div
                    key={subField.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: 500,
                    }}
                  >
                    {subField.isTag ? (
                      renderTag(subField.value)
                    ) : (
                      <span>{subField.value}</span>
                    )}
                  </div>
                ))}
              </div>
            </>
          ))}
        </div>
      );
    }

    return (
      <div
        key={item.key || item.name}
        style={{
          display: "flex",
          borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#f9f9f9",
            fontWeight: "500",
            borderRight: "1px solid #f0f0f0",
          }}
        >
          {item.name}
        </div>
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#fff",
          }}
        >
          {item.isTag ? (
            renderTag(item.value)
          ) : (
            <Text style={{ textTransform: "capitalize", fontWeight: 600 }}>
              {item.value}
            </Text>
          )}
        </div>
      </div>
    );
  };

  return (
    <div style={{ width: "100%" }}>
      <h2 style={{ margin: 0, fontSize: "24px", marginBottom: "24px" }}>
        Charge Details
      </h2>

      {data.map((section, sectionIndex) => (
        <div key={section.section}>
          <div
            style={{
              border: "1px solid #f0f0f0",
              borderRadius: "8px",
              marginBottom: "24px",
            }}
          >
            {section.items.map((item, index) =>
              renderRow(item, index, sectionIndex)
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ChargeDetails;
